module.exports = __webpack_public_path__ + "static/media/shape1.553b9128.png";